import { styles } from '@webclient/lib/agent';
import { live } from '@webclient/lib/agent/endpoints/live';

import { setCustomStyleByUserId } from '@webclient/state/slices/app-settings';
import { RootType } from '@webclient/state/store';

import { SearchRequestType } from '@webclient/shared-types/search-result/types';

import { createAsyncThunk } from '@reduxjs/toolkit';

const VOICE_DEFAULT = 'Professional and Formal';
const PERSONALITY_DEFAULT = 'Intellectual and Analytical';

const createAsyncSearchThread = createAsyncThunk(
  'searchSession/createSearchThread',
  async (args: SearchRequestType, { getState, dispatch }) => {
    const state = getState() as RootType;
    const appSettingsState = state.appSettings;

    if (!state.auth.me) {
      throw new Error('User not found');
    }

    const me = state.auth.me;
    const userSpecificSettings = appSettingsState.userSpecificSettings[me.uuid];
    const customStyle = userSpecificSettings.customStyle;
    const useCustomStyle = userSpecificSettings.useCustomStyle;
    const searchScope = userSpecificSettings.searchScope;
    const lat = appSettingsState.userGeoLocation.lat;
    const lng = appSettingsState.userGeoLocation.lng;

    const newCustomStyle = {
      ...customStyle,
    };

    if (useCustomStyle && newCustomStyle.responseStyle) {
      if (!newCustomStyle.id) {
        await persistCustomStyle();
      } else if (!newCustomStyle.isUpToDate) {
        await updateCustomStyle();
      }

      args.style = newCustomStyle.id;
    }

    if (searchScope === 'web_only') {
      args.allKnowledgeBase = false;
    } else if (searchScope === 'web_kb') {
      args.allKnowledgeBase = true;
    } else if (searchScope === 'kb_only') {
      args.allKnowledgeBase = true;
    }

    args.context = {
      latLng: [lat, lng],
      language: navigator.language,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      zonosTts: userSpecificSettings.voice.zonos ?? false,
    };

    const { data } = await live.createLiveSearch(args);
    return data;

    async function persistCustomStyle() {
      const {
        data: { id },
      } = await styles.create({
        instructions: '',
        voice: VOICE_DEFAULT,
        personality: PERSONALITY_DEFAULT,
        responseStyle: customStyle.responseStyle,
      });

      newCustomStyle.id = id;
      newCustomStyle.isUpToDate = true;
      dispatch(
        setCustomStyleByUserId({
          userId: me!.uuid,
          customStyle: newCustomStyle,
        }),
      );
    }

    async function updateCustomStyle() {
      await styles.updateOne(newCustomStyle.id!, {
        responseStyle: newCustomStyle.responseStyle,
      });

      newCustomStyle.isUpToDate = true;
      dispatch(
        setCustomStyleByUserId({
          userId: me!.uuid,
          customStyle: newCustomStyle,
        }),
      );
    }
  },
);

export default createAsyncSearchThread;
